import { Avatar, Box } from '@mui/material';
import styled from 'styled-components';

export const ServiceList = styled(Box)`
  margin: ${({ theme }) => theme.spacing(1)} 0;
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.spacing(1)};
`;

export const ServiceIcon = styled(Avatar)`
  height: 1.3rem;
  width: 1.3rem;
  border-radius: 2px;
  color: ${({ theme }) => theme.palette.text.primary};
  background: white;
`;
